import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import Button from '../Buttons/Button'
import Typography from '../Typography'

type Timer1Props = {
  initialSeconds: number
  initialMinutes: number
  showText?: boolean
  onResetTimer?: () => void
}

const CountdownTimer = ({ initialSeconds, initialMinutes, showText = true, onResetTimer }: Timer1Props) => {
  const [seconds, setSeconds] = useState(initialSeconds)
  const [minutes, setMinutes] = useState(initialMinutes)

  const { t } = useTranslation()

  const handleResetTimer = () => {
    setMinutes(initialMinutes)
    setSeconds(initialSeconds)
    onResetTimer?.()
  }

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval)
        } else {
          setMinutes(minutes - 1)
          setSeconds(59)
        }
      }
    }, 1000)
    return () => {
      clearInterval(myInterval)
    }
  }, [minutes, seconds])

  if (!showText) {
    return (
      <Typography as='span' variant='subbody' weight='bold'>{`${minutes}:${
        seconds < 10 ? `0${seconds}` : seconds
      }`}</Typography>
    )
  }

  return (
    <div>
      {minutes === 0 && seconds === 0 ? (
        <Button variant='link' onClick={handleResetTimer}>
          Переотправить код
        </Button>
      ) : (
        <Typography variant='subbody' twStyle={tw`text-grey-dark`}>
          {t('flow-resend-code')}{' '}
          <Typography as='span' variant='subbody' weight='bold'>{`${minutes}:${
            seconds < 10 ? `0${seconds}` : seconds
          }`}</Typography>
        </Typography>
      )}
    </div>
  )
}

export default CountdownTimer
